export function getBaseUrl() {
	// Prefer server-only canonical URL when available (e.g. Vercel Production).
	if (process.env.SITE_URL) {
		return process.env.SITE_URL;
	}
	// Fallback for client-facing configuration (legacy).
	if (process.env.NEXT_PUBLIC_SITE_URL) {
		return process.env.NEXT_PUBLIC_SITE_URL;
	}
	// Vercel provides `VERCEL_URL` (hostname without protocol) in deployments.
	if (process.env.VERCEL_URL) {
		return `https://${process.env.VERCEL_URL}`;
	}
	return `http://localhost:${process.env.PORT ?? 3000}`;
}
